/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ADL意思疎通
 */
export type RequestSummaryADLCommunicationEnum =
  (typeof RequestSummaryADLCommunicationEnum)[keyof typeof RequestSummaryADLCommunicationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryADLCommunicationEnum = {
  POSSIBLE: 'POSSIBLE',
  PARTIAL: 'PARTIAL',
  IMPOSSIBLE: 'IMPOSSIBLE',
} as const;
